import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OuiButton } from 'omnium-ui/button';

@Component({
  selector: 'lib-technical-error-page',
  imports: [OuiButton],
  templateUrl: './technical-error-page.component.html',
  styleUrl: './technical-error-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TechnicalErrorPageComponent {
  reloadPage() {
    window.location.reload();
  }
}
